import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0fd49162 = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _27c9fb88 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _52ed0658 = () => interopDefault(import('../modules/checkout/pages/Checkout/Billing.vue' /* webpackChunkName: "" */))
const _7538cedf = () => interopDefault(import('../modules/checkout/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _3a605425 = () => interopDefault(import('../modules/checkout/pages/Checkout/Shipping.vue' /* webpackChunkName: "" */))
const _23ee1fcc = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _7be7323b = () => interopDefault(import('../modules/checkout/pages/Checkout/UserAccount.vue' /* webpackChunkName: "" */))
const _536abfb4 = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _12122860 = () => interopDefault(import('../pages/Compare.vue' /* webpackChunkName: "" */))
const _7ef76eee = () => interopDefault(import('../pages/ContactUs.vue' /* webpackChunkName: "pages/ContactUs" */))
const _41e241d9 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _4310a372 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _6f859286 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "" */))
const _615319fa = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _605c04c7 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyReviews.vue' /* webpackChunkName: "" */))
const _ab4ce66e = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _582c5b87 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _049f7782 = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _4b35f453 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _2b8da6e7 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _73606d0c = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _f86e5bf8 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _58043098 = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _87be7966 = () => interopDefault(import('../pages/ProductNews.vue' /* webpackChunkName: "pages/ProductNews" */))
const _083cc90a = () => interopDefault(import('../pages/SearchResult.vue' /* webpackChunkName: "" */))
const _781ba024 = () => interopDefault(import('../pages/Success.vue' /* webpackChunkName: "" */))
const _430fceee = () => interopDefault(import('../pages/__vsf_tests__/contactData.mock.ts' /* webpackChunkName: "pages/__vsf_tests__/contactData.mock" */))
const _fe314dba = () => interopDefault(import('../pages/__vsf_tests__/SearchResultDataMock.ts' /* webpackChunkName: "pages/__vsf_tests__/SearchResultDataMock" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/spring-wire/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cart",
    component: _0fd49162,
    name: "cart___zh"
  }, {
    path: "/checkout",
    component: _27c9fb88,
    name: "checkout___zh",
    children: [{
      path: "billing",
      component: _52ed0658,
      name: "billing___zh"
    }, {
      path: "payment",
      component: _7538cedf,
      name: "payment___zh"
    }, {
      path: "shipping",
      component: _3a605425,
      name: "shipping___zh"
    }, {
      path: "thank-you",
      component: _23ee1fcc,
      name: "thank-you___zh"
    }, {
      path: "user-account",
      component: _7be7323b,
      name: "user-account___zh"
    }]
  }, {
    path: "/Cms",
    component: _536abfb4,
    name: "Cms___zh"
  }, {
    path: "/compare",
    component: _12122860,
    name: "compare___zh"
  }, {
    path: "/Compare",
    component: _12122860,
    name: "Compare___zh"
  }, {
    path: "/ContactUs",
    component: _7ef76eee,
    name: "ContactUs___zh"
  }, {
    path: "/customer",
    component: _41e241d9,
    meta: {"titleLabel":"My Account"},
    name: "customer___zh",
    children: [{
      path: "addresses-details",
      component: _4310a372,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___zh"
    }, {
      path: "my-newsletter",
      component: _6f859286,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___zh"
    }, {
      path: "my-profile",
      component: _615319fa,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___zh"
    }, {
      path: "my-reviews",
      component: _605c04c7,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___zh"
    }, {
      path: "my-wishlist",
      component: _ab4ce66e,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___zh"
    }, {
      path: "order-history",
      component: _582c5b87,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___zh"
    }, {
      path: "/reset-password",
      component: _049f7782,
      alias: "/customer/account/createPassword",
      name: "reset-password___zh"
    }, {
      path: "addresses-details/create",
      component: _4b35f453,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___zh"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _2b8da6e7,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___zh"
    }, {
      path: "order-history/:orderId",
      component: _73606d0c,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___zh"
    }]
  }, {
    path: "/en",
    component: _f86e5bf8,
    name: "home___en"
  }, {
    path: "/Home",
    component: _f86e5bf8,
    name: "Home___zh"
  }, {
    path: "/Page",
    component: _58043098,
    name: "Page___zh"
  }, {
    path: "/ProductNews",
    component: _87be7966,
    name: "ProductNews___zh"
  }, {
    path: "/search-result",
    component: _083cc90a,
    name: "search___zh"
  }, {
    path: "/SearchResult",
    component: _083cc90a,
    name: "SearchResult___zh"
  }, {
    path: "/success",
    component: _781ba024,
    name: "success___zh"
  }, {
    path: "/Success",
    component: _781ba024,
    name: "Success___zh"
  }, {
    path: "/en/cart",
    component: _0fd49162,
    name: "cart___en"
  }, {
    path: "/en/checkout",
    component: _27c9fb88,
    name: "checkout___en",
    children: [{
      path: "billing",
      component: _52ed0658,
      name: "billing___en"
    }, {
      path: "payment",
      component: _7538cedf,
      name: "payment___en"
    }, {
      path: "shipping",
      component: _3a605425,
      name: "shipping___en"
    }, {
      path: "thank-you",
      component: _23ee1fcc,
      name: "thank-you___en"
    }, {
      path: "user-account",
      component: _7be7323b,
      name: "user-account___en"
    }]
  }, {
    path: "/en/Cms",
    component: _536abfb4,
    name: "Cms___en"
  }, {
    path: "/en/compare",
    component: _12122860,
    name: "compare___en"
  }, {
    path: "/en/Compare",
    component: _12122860,
    name: "Compare___en"
  }, {
    path: "/en/ContactUs",
    component: _7ef76eee,
    name: "ContactUs___en"
  }, {
    path: "/en/customer",
    component: _41e241d9,
    meta: {"titleLabel":"My Account"},
    name: "customer___en",
    children: [{
      path: "addresses-details",
      component: _4310a372,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___en"
    }, {
      path: "my-newsletter",
      component: _6f859286,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___en"
    }, {
      path: "my-profile",
      component: _615319fa,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___en"
    }, {
      path: "my-reviews",
      component: _605c04c7,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___en"
    }, {
      path: "my-wishlist",
      component: _ab4ce66e,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___en"
    }, {
      path: "order-history",
      component: _582c5b87,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___en"
    }, {
      path: "addresses-details/create",
      component: _4b35f453,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___en"
    }, {
      path: "/en/reset-password",
      component: _049f7782,
      alias: "/customer/account/createPassword",
      name: "reset-password___en"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _2b8da6e7,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___en"
    }, {
      path: "order-history/:orderId",
      component: _73606d0c,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___en"
    }]
  }, {
    path: "/en/Home",
    component: _f86e5bf8,
    name: "Home___en"
  }, {
    path: "/en/Page",
    component: _58043098,
    name: "Page___en"
  }, {
    path: "/en/ProductNews",
    component: _87be7966,
    name: "ProductNews___en"
  }, {
    path: "/en/search-result",
    component: _083cc90a,
    name: "search___en"
  }, {
    path: "/en/SearchResult",
    component: _083cc90a,
    name: "SearchResult___en"
  }, {
    path: "/en/success",
    component: _781ba024,
    name: "success___en"
  }, {
    path: "/en/Success",
    component: _781ba024,
    name: "Success___en"
  }, {
    path: "/en/contact/:subject?",
    component: _7ef76eee,
    name: "contact___en"
  }, {
    path: "/contact/:subject?",
    component: _7ef76eee,
    name: "contact___zh"
  }, {
    path: "/en/:_vsf_tests__?/contactData.mock",
    component: _430fceee,
    name: "_vsf_tests__-contactData.mock___en"
  }, {
    path: "/en/:_vsf_tests__?/SearchResultDataMock",
    component: _fe314dba,
    name: "_vsf_tests__-SearchResultDataMock___en"
  }, {
    path: "/en/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5",
    component: _58043098,
    name: "page___en"
  }, {
    path: "/",
    component: _f86e5bf8,
    name: "home___zh"
  }, {
    path: "/:_vsf_tests__?/contactData.mock",
    component: _430fceee,
    name: "_vsf_tests__-contactData.mock___zh"
  }, {
    path: "/:_vsf_tests__?/SearchResultDataMock",
    component: _fe314dba,
    name: "_vsf_tests__-SearchResultDataMock___zh"
  }, {
    path: "/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5",
    component: _58043098,
    name: "page___zh"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
